import { jsx } from "react/jsx-runtime";
import { createContext, useState, useEffect, useContext } from "react";
const initialState = {
  theme: "system",
  setTheme: () => null,
  actualTheme: "light"
};
const ThemeProviderContext = createContext(initialState);
function ThemeProvider({
  children,
  defaultTheme = "system",
  storageKey = "ui-theme",
  ...props
}) {
  const [theme, setTheme] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem(storageKey) || defaultTheme;
    }
    return defaultTheme;
  });
  const [actualTheme, setActualTheme] = useState("light");
  useEffect(() => {
    const htmlRoot = window.document.documentElement;
    const appRoot = document.getElementById("easycommerce-admin-root") || document.getElementById("easycommerce-store-root") || document.getElementById("root") || document.querySelector("[data-theme-root]");
    let resolvedTheme = "light";
    if (theme === "system") {
      resolvedTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    } else {
      resolvedTheme = theme;
    }
    htmlRoot.classList.remove("light", "dark");
    htmlRoot.classList.add(resolvedTheme);
    if (appRoot) {
      appRoot.classList.remove("light", "dark");
      appRoot.classList.add(resolvedTheme);
    }
    setActualTheme(resolvedTheme);
  }, [theme]);
  useEffect(() => {
    if (theme === "system") {
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
      const handleChange = (e) => {
        const resolvedTheme = e.matches ? "dark" : "light";
        const root = window.document.documentElement;
        root.classList.remove("light", "dark");
        root.classList.add(resolvedTheme);
        setActualTheme(resolvedTheme);
      };
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    }
  }, [theme]);
  const value = {
    theme,
    setTheme: (theme2) => {
      localStorage.setItem(storageKey, theme2);
      setTheme(theme2);
    },
    actualTheme
  };
  return /* @__PURE__ */ jsx(ThemeProviderContext.Provider, { ...props, value, children });
}
const useTheme = () => {
  const context = useContext(ThemeProviderContext);
  if (context === void 0) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
export {
  ThemeProvider,
  useTheme
};
//# sourceMappingURL=theme-context.js.map
